import React, { PropTypes } from 'react';
import Form, { CheckBoxInput, DateInput, FormActions, FormBody, SelectInput } from "../../Form";
import { inject, observer } from "mobx-react/index";
import { observable, action } from 'mobx';
import FormMultiSelectInput from "../../FormMultiSelectInput";
import moment from "moment/moment";
import _ from 'lodash';
import { insertMissingTimeStampData } from '../../../libs/localStorage';

@inject('stationStore', 'parameterStore', 'tagStore','dataSourceStore')
@observer
class AnalysisData extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  @observable missingTimestamps = insertMissingTimeStampData.get();
  @observable multiStationOptions = [];
  @observable multiParameterOptions = [];
  @observable multiFunctionOptions = [
    { id: 1, name: "Min", label: "Min", value: false, },
    { id: 2, name: "Avg", label: "Avg", value: false, },
    { id: 3, name: "Max", label: "Max", value: false, },
    { id: 4, name: "Sum", label: "Sum", value: false, },
  ];

  @observable period = 'None';
  @observable aggregationType = 'left_closed_right_open';
  @observable date = {
    from: moment().subtract(1, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
    to: moment().format('YYYY-MM-DDTHH:mm:ss'),
  };
  @observable showAllParameters = false;

  dispose;
  componentWillMount() {
    const { stationStore, parameterStore, tagStore, dataSourceStore } = this.props;

    if (!stationStore.isLoading && stationStore.items.length === 0) stationStore.fetchItems();
    if (!parameterStore.isLoading && parameterStore.items.length === 0) parameterStore.fetchItems();
    if (!tagStore.isLoading && tagStore.items.length === 0) tagStore.fetchItems();
    if (!dataSourceStore.isLoading && dataSourceStore.items.length === 0) dataSourceStore.fetchItems();

    this.populateOptions();
  }

  populateOptions = () => {
    const { stationStore, parameterStore } = this.props;
    if (stationStore.items.length === 0 || parameterStore.items.length === 0) {
      setTimeout(() => {
        this.populateOptions();
      }, 300)
    } else {
      // if (process.env.NODE_ENV !== 'production') {
      //   // view hydrology
      //   // this.multiStationOptions = stationStore.items.map(item => ({id: item.id, label: item.name, tags: item.tags, value: [77,78,28,41,107].indexOf(item.id) > -1}));
      //   this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, tags: item.tags, value: [28, 78, 238].indexOf(item.id) > -1 }));
      //   this.multiParameterOptions = parameterStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, code: item.code, value: [2, 97].indexOf(item.id) > -1 }));
      //   this.onView()
      //
      //   // // view pollution
      //   // this.multiStationOptions = stationStore.items.map(item => ({id: item.id, label: item.name, tags: item.tags, value: [11, 107].indexOf(item.id) > -1}));
      //   // this.multiParameterOptions = parameterStore.items.map(item => ({id: item.id, label: item.name, value: [20, 34, 15, 12,3,274,23,24,8,6,31,30,54,105,106].indexOf(item.id) > -1}));
      //   // this.onView()
      //
      //   // // view imza
      //   // this.multiStationOptions = stationStore.items.map(item => ({id: item.id, label: item.name, value: item.name.toLowerCase().indexOf('imza') > -1}));
      //   // this.multiParameterOptions = parameterStore.items.map(item => ({id: item.id, label: item.name, value: [109, 179].indexOf(item.id) > -1}));
      //   // this.onView()
      // } else {
      this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: false, tags: item.tags }));
      // this.multiParameterOptions = parameterStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: false, code: item.code }));
      this.multiParameterOptions = parameterStore.items.reduce((acc, item) => {
        if(item.table === 2) return acc; // filter out the parameters which is table value is 2 which is not use in the analysis cause its txt value
        acc.push({ id: item.id, name: item.name, label: item.name, value: false, code: item.code });
        return acc;
      }, [])
    }
  };

  onChangeDate = (field, value) => this.date[field] = value;
  @action onMissingChange = e => {
    this.missingTimestamps = e.target.checked
    insertMissingTimeStampData.set(e.target.checked);
  }

  @action onStationOptionClicked = item => item.value = !item.value;
  @action onParameterOptionClicked = item => item.value = !item.value;
  @action onFunctionOptionClicked = item => item.value = !item.value;

  optionsReducer = options => options.reduce((acc, item) => {
    if (item.value === true) acc.push(item.id);
    return acc;
  }, []);

  onView = (e) => {
    if (e) e.preventDefault();
    this.context.router.push('/analysis/data/view')
  };

  filterStations = (stations, filterText) => {
    return stations.filter(station => (
      (station &&
        station.label &&
        station.label.toLowerCase().indexOf(filterText) !== -1) ||

      (station &&
        station.tags &&
        station.tags.reduce((acc, tag) => {
          if (tag.name.toLowerCase().indexOf(filterText) !== -1) {
            return true;
          }
          return acc;
        }, false))
    ))
  };

  @action
  onChangePeriod = (e) => {
    this.period = e.target.value;
  }

  @action
  onChangeAggregationType = (e) => {
    this.aggregationType = e.target.value;
  }

  filterParameters = (parameterOptions, stationOptions) => {
    const { dataSourceStore } = this.props;
    let selectedStations = stationOptions.filter(item => item.value);

    // let stationTags = _.uniq(_.flattenDeep(selectedStations.map(item => !item.tags ? [] : item.tags.map(item => item.id))));
    // let tags = tagStore.items.filter(item => stationTags.indexOf(item.id) > -1);
    // let tagParameters = _.uniq(_.flattenDeep(tags.map(item => !item.parameters ? [] : item.parameters.map(item => item.id))));
    // console.log(tagParameters);
    // return this.showAllParameters ? parameterOptions : parameterOptions.filter(item => tagParameters.indexOf(item.id) > -1);

    const parameters = _.uniq(_.flattenDeep(dataSourceStore.items.map((item) => {
      let data1 =  item.origins && item.origins.map((item2) => {
        if (item2.stations && item2.stations.length > 0) {
        const matchedStations = item2.stations.filter((item3) =>selectedStations.some(selectedItem => selectedItem.id == item3.id))
         return matchedStations.length > 0 ? item2.data_origin_parameters : null
        }
      })
      return  data1 && data1.length > 0 && data1.filter((data) => data != null)  
  }))).map((item) => item.parameter_id)

  return  this.showAllParameters ? parameterOptions : parameterOptions.filter(item => parameters.indexOf(item.id) > -1);

}

  render() {
    const { stationStore, parameterStore, children } = this.props;

    // console.log(this.multiStationOptions.filter(item => item.value === true))

    if (children) return React.cloneElement(children, {
      period: this.period,
      aggregationType: this.aggregationType,
      missingTimestamps: this.missingTimestamps,
      func: this.multiFunctionOptions.reduce((acc, val) => {
        if (val.value) {
          return [...acc, val.name];
        } else
          return acc;
      }, []),
      stations: this.optionsReducer(this.multiStationOptions),
      parameters: this.optionsReducer(this.multiParameterOptions),
      ...this.date
    });

    return (
      <div>
        <Form>
          <FormBody>
            <FormMultiSelectInput id='station-multi-select' label='Stations' options={this.multiStationOptions} optionClicked={this.onStationOptionClicked} isLoading={stationStore.isLoading} filterOptions={stationStore.filterStations} />
            <div className='inline-grid'>
              <FormMultiSelectInput id='parameter-multi-select' label='Parameters' options={this.filterParameters(this.multiParameterOptions, this.multiStationOptions)} optionClicked={this.onParameterOptionClicked} isLoading={parameterStore.isLoading} filterOptions={parameterStore.filterParameters} />
              <CheckBoxInput label='Show All' value={this.showAllParameters} onChange={() => this.showAllParameters = !this.showAllParameters} />
            </div>
            <DateInput
              label={'Date From'}
              type="datetime-local"
              value={moment(this.date.from).format('YYYY-MM-DDTHH:mm:ss')}
              onChange={e => this.onChangeDate('from', e.target.value)}
            />
            <DateInput
              label={'Date To'}
              type="datetime-local"
              value={moment(this.date.to).format('YYYY-MM-DDTHH:mm:ss')}
              onChange={e => this.onChangeDate('to', e.target.value)}
            />
            <SelectInput
              label={'Aggregation'}
              value={this.period}
              fields={{ label: 'name', value: 'name' }}
              options={[
                { name: 'None' },
                { name: 'Hourly' },
                { name: 'Daily' },
                { name: 'Monthly' },
                { name: 'Annually' },
              ]}
              onChange={this.onChangePeriod}
            />
            {this.period !== 'None' && <FormMultiSelectInput
              id='function-multi-select'
              label={'Functions'}
              options={this.multiFunctionOptions}
              optionClicked={this.onFunctionOptionClicked}
            />}
            {this.period !== 'None' && <SelectInput
              value={this.aggregationType}
              label={'Aggregation Type'}
              fields={{ label: 'name', value: 'value' }}
              options={[
                { name: 'Left Closed Right Open', value: 'left_closed_right_open' },
                { name: 'Right Closed Left Open', value: 'right_closed_left_open' },
              ]}
              onChange={this.onChangeAggregationType}
            />}
            <div className='formInput'>
              <label>Insert timestamp for missing data</label>
              <input type="checkbox" checked={this.missingTimestamps} onChange={this.onMissingChange} />
            </div>
          </FormBody>
          <FormActions>
            <button onClick={this.onView}>View</button>
          </FormActions>
        </Form>
        {/*{children && React.cloneElement(children, {stations: this.optionsReducer(this.multiStationOptions), parameters: this.optionsReducer(this.multiParameterOptions), ...this.date})}*/}
      </div>
    );
  }
}

export default AnalysisData;


// WEBPACK FOOTER //
// ./src/components/Analysis/Data/AnalysisData.js